<template>
    <b-container fluid class="d-flex flex-column position-fixed p-0 m-0 h-100 w-100 loginBackground">
        <b-card class="m-auto shadow-sm px-3 py-0 bg-white" no-body style="min-height: 23rem; min-width: 30rem; padding:40px; z-index:5">
            <b-card-body v-if="ShowForm" class="pt-4 flex-grow-1">
                <b-form class="p-3 py-4">
                    <b-container class="p-0">
                        <b-row align-h="center" align-v="center">
                            <!-- Bienvenue sur DeltaConso Expert ! -->
                            <!-- Réactiver votre compte -->
                            <!-- Réinitialiser votre mot de passe -->
                            <b-col cols="auto"><h5 class="m-0">{{ Title }}</h5></b-col>
                        </b-row>
                        <!-- Locker-arrow-circle.webp -->
                        <b-row v-if="ShowResetIllustration" align-h="center" class="pt-4"><b-col cols="auto"><img src="..\public\icons\Locker-arrow-circle.webp" style="height: 60px; width: 60px; bottom: 0;"/></b-col></b-row>
                        <!-- Votre adresse mail a été vérifié avec succès.-->
                        <!-- Il ne vous reste plus qu'a définir votre nouveau mot de passe -->
                        <!-- Veuillez définir votre nouveau mot de passe -->
                        <b-row align-h="center" class="pt-4"><b-col cols="auto">{{ FirstExplainLine }}</b-col></b-row>
                        <!-- Pour finaliser votre inscription, veuillez choisir un mot de passe : -->
                        <b-row align-h="center" class="pb-4"><b-col cols="auto">{{ SecondExplainLine }}</b-col></b-row>
                        <b-row align-h="center" class="pt-2">
                            <b-col cols="10">
                                <!-- Login (e-mail par défaut) avec case à cocher -->
                                <b-form-group >
                                    <b-form-input disabled type="text" v-model="login"/>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        
                        <b-row align-h="center" class="py-2">
                            <b-col cols="10">
                                <PasswordInput 
                                    v-model="password" 
                                    :EnableOldPassword="false" 
                                    :HasPasswordPolicy="hasPasswordPolicy" 
                                    :MinCharLength="minCharLength" 
                                    :MinUpperCase="minUpperCase" 
                                    :MinDigit="minDigit" 
                                    :MinSpecialChar="minSpecialChar"
                                    :ListSpecialChar="listSpecialChar"/>
                            </b-col>
                        </b-row>
                        <b-row align-h="center" class="pt-4">
                            <b-col cols="10">
                                <!-- Confirmer l'inscription -->
                                <!-- Enregistrer -->
                                <!-- Modifier le mot de passe -->
                                <b-button @click="state.Next()" pill :disabled="login.length === 0 || (password.length < 1)" class="w-100" variant="primary">{{ SubmitText }}</b-button>
                            </b-col>
                        </b-row>
                    </b-container>
                </b-form>
            </b-card-body>
            <b-card-body v-else-if="showError" class="pt-4 flex-grow-1">
                <div class="d-flex p-4">
                    <img src="../assets/images/DCX_2020.png" style="height: 2.80rem; width: 11.87rem;" class="m-auto" />
                </div>
                <b-card-text class="text-danger">
                    {{ $t('GenericErrorMessage')  }}
                </b-card-text>
            </b-card-body>
        </b-card>
    </b-container>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import locales from "./locales/RegistrationPage.json";
import { IRegistrationState } from './RegistrationPage/RegistrationState';
import { RegStateStart } from './RegistrationPage/RegStateStart';
import PasswordInput from './commons/PasswordInput.vue';

/** Composant pour l'inscription des utilisateurs */
@Component({
    components:{
        PasswordInput
    },
    i18n: { messages: locales }
})
export default class RegistrationPage extends Vue{
    /** Machine à état en charge des étapes de validation successive de la page */
    private state!: IRegistrationState;

    /** Permet d'afficher le formulaire */
    private showForm: boolean = false;

    /** Permet d'afficher l'erreur */
    private showError: boolean = false;

    /** Indique si l'on fait face à une situation de première enregistrement ou bien un simple changement de mot de passe */
    private isRegister: boolean = true;

    /** Titre de l'encar affiché lors de la réussite de la validation */
    private validateTitle: string = "";

    /** Message de affiché lors de la réussite de la validation */
    private validateSuccessMessage: string = "";

    /** Message de affiché lors de l'echec de la validation */
    private validateFailMessage: string = "";

    /** Titre de la page */
    private title: string = "";

    /** Affiche le login de l'utilisateur */
    private showLogin: boolean = false;
  
    /** Texte de la première ligne d'explication */
    private firstExplainLine: string = "";
    
    /** Texte de la seconde ligne d'explication */
    private secondExplainLine: string = "";

    /** Texte du button de validation */
    private submitText: string = "";

    /** Chemin de l'icône d'illustration (flag d'affichage) */
    private showResetIllustration: boolean = false;

    /** Login de l'utilisateur récupéré via le token */
    private login: string = "";

    /** Mot de passe */
    private password: string = "";

    //#region PARAMETRES DE VALIDATION
    /** Détermine si la politique de validation doit s'appliquer */
    private hasPasswordPolicy: boolean = true;

    /** Minimum de caractère necessaire pour valider le mot de passe */
    private minCharLength: number = 8;
    
    /** Minimun de lettre majuscule pour valider le mot de passe */
    private minUpperCase: number = 1;
    
    /** Minimum de chiffre pour valider le mot de passe */
    private minDigit: number = 1;
    
    /** Minimum de caractère spéciaux pour valider le mot de passe */
    private minSpecialChar: number = 1;
    
    /** Liste de caractère spéciaux autorisé */
    private listSpecialChar: string = ".+-_*#?!@";
    //#endregion PARAMETRES DE VALIDATION

    /** Changement d'état */
	public TransitionTo(state: IRegistrationState): void {
		this.state = state;
	}

    /** Fait avancer la machine à état */
    public async Next(){
        await this.state.Next();
    }

    async created(){
        this.TransitionTo(new RegStateStart(this))
        await this.Next();
    }

    //#region GETTEUR / SETTEUR pour machine à états
    public get Title(): string { return this.title; }
    public set Title(value: string) { this.title = value; }

    public get ShowLogin(): boolean { return this.showLogin; }
    public set ShowLogin(value: boolean) { this.showLogin = value; }

    public get FirstExplainLine(): string { return this.firstExplainLine; }
    public set FirstExplainLine(value: string) { this.firstExplainLine = value; }

    public get SecondExplainLine(): string { return this.secondExplainLine; }
    public set SecondExplainLine(value: string) { this.secondExplainLine = value; }

    public get SubmitText(): string { return this.submitText; }
    public set SubmitText(value: string) { this.submitText = value; }

    public get ShowResetIllustration(): boolean { return this.showResetIllustration; }
    public set ShowResetIllustration(value: boolean) { this.showResetIllustration = value; }

    public get ShowForm(): boolean { return this.showForm; }
    public set ShowForm(value: boolean) { this.showForm = value; }

    public get ValidateTitle(): string { return this.validateTitle; }
    public set ValidateTitle(value: string) { this.validateTitle = value; }

    public get ValidateSuccessMessage(): string { return this.validateSuccessMessage; }
    public set ValidateSuccessMessage(value: string) { this.validateSuccessMessage = value; }

    public get ValidateFailMessage(): string { return this.validateFailMessage; }
    public set ValidateFailMessage(value: string) { this.validateFailMessage = value; }

    public get ShowError(): boolean { return this.showError; }
    public set ShowError(value: boolean) { this.showError = value; }

    public get IsRegister(): boolean { return this.isRegister; }
    public set IsRegister(value: boolean) { this.isRegister = value; }

    public get Login(): string { return this.login; }
    public set Login(value: string) { this.login = value; }

    public get Password(): string { return this.password; }
    public set Password(value: string) { this.password = value; }

    public get HasPasswordPolicy(): boolean { return this.hasPasswordPolicy; }
    public set HasPasswordPolicy(value: boolean) { this.hasPasswordPolicy = value; }

    public get MinCharLength(): number { return this.minCharLength; }
    public set MinCharLength(value: number) { this.minCharLength = value; }

    public get MinUpperCase(): number { return this.minUpperCase; }
    public set MinUpperCase(value: number) { this.minUpperCase = value; }

    public get MinDigit(): number { return this.minDigit; }
    public set MinDigit(value: number) { this.minDigit = value; }

    public get MinSpecialChar(): number { return this.minSpecialChar; }
    public set MinSpecialChar(value: number) { this.minSpecialChar = value; }

    public get ListSpecialChar(): string { return this.listSpecialChar; }
    public set ListSpecialChar(value: string) { this.listSpecialChar = value; }
    //#endregion GETTEUR / SETTEUR pour machine à états
} 

</script>

<style scoped>
/** Affichage de l'image de fond */
.loginBackground{
        background-position: center;
        background: url("../assets/images/backgrounds/Connexion.webp") no-repeat center fixed;
        background-size: cover;
    }
</style>